import React from 'react'
import { DELETE_CHALLENGE_MODAL } from 'features/challenges/modals/DeleteChallengeModal'
import { COPY_CHALLENGE_MODAL } from 'features/challenges/modals/CopyChallengeModal'
import { challengeMessages } from 'features/challenges/intlMessages'
import { SideNav, SideNavHeader, SideNavActions, SideNavAction } from 'common/layouts/SideNavLayout/SideNav'
import { useFormatMessage, featureNames, commonNouns, commonVerbs, commonCTAs, commonActions, goalTypeLabels } from 'lib/localization'
import { showModal } from 'lib/modalUtils'
import { c } from 'lib/textUtils'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  create: {
    id: 'adminSideNav.create',
    defaultMessage: 'Create Challenge'
  }
})

export const ChallengesSideNav = ({ goalId, clubId, collapseState }) => {
  const fm = useFormatMessage()
  const links = [
    { title: fm(commonNouns.overview), to: `/challenges/${goalId}/overview`, icon: 'md-home' },
    { title: fm(commonNouns.details), to: `/challenges/${goalId}/details`, icon: 'md-calendar' },
    { title: fm(featureNames.settings), to: `/challenges/${goalId}/settings`, icon: 'menu-settings-icon' },
    { title: fm(goalTypeLabels.leaderboard), to: `/challenges/${goalId}/leaderboard`, icon: 'md-star' },
    { title: fm(challengeMessages.participants), to: `/challenges/${goalId}/participants`, icon: 'md-people' }
  ].filter(x => x)

  return (
    <SideNav links={links}>
      {!collapseState && <SideNavHeader>
        {fm(messages.create)}
      </SideNavHeader>}
      <SideNavActions>
        {!collapseState && <>
          <SideNavAction onClick={() => showModal(COPY_CHALLENGE_MODAL, { goalId })} i='md-copy' label={c(fm(commonActions.copy))} />
          <SideNavAction onClick={() => showModal(DELETE_CHALLENGE_MODAL, { goalId, clubId })} i='md-trash' label={fm(commonVerbs.delete)} />
          <SideNavAction onClick={() => { window.location = `/clubs/${clubId}` }} i='ios-arrow-back' label={fm(commonCTAs.backToAccount)} />
        </>}
      </SideNavActions>
    </SideNav>
  )
}
